module.exports = __webpack_public_path__ + "img/血竭.654937fb.jpg";